import { NgForm } from '@angular/forms';
import { Injectable } from "@angular/core";

@Injectable()
export class FormInvalidatorService {

  invalidate(formRef: NgForm, notMandatoryControls: string[]): void {
        const controls = formRef.controls;
        Object.keys(controls).forEach(key => {
            if (notMandatoryControls.indexOf(key) === -1) {
            const control = formRef.control.get(key);
            if (control.value === '' || control.value === undefined || control.value === null) {
              control.markAsTouched();
              control.setErrors({'invalid': true});
            } else {
              control.markAsPristine();
            }
          }
        });
    }
}
